import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/:identificador/nps/:npsId",
  name: "Nps",
  component: function component() {
    return import(/* webpackChunkName: "publico" */"./page/Nps.vue");
  },
  meta: {
    titulo: "Nps",
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: true
  }
}];